import { all, fork } from 'redux-saga/effects';

import userMasterSaga from './user/saga';

export default function* rootSaga() {
  yield all([fork(userMasterSaga)]);
}
